import React from 'react';
import { Dialog, DialogButton } from '@guildeducationinc/recess';

export interface ConfirmationOptions {
  catchOnCancel?: boolean;
  title: string;
  descriptionElement: React.ReactElement;
  cancelButtonText?: string;
  cancelButtonIntent?: DialogButton['intent'];
  confirmButtonText?: string;
  confirmButtonIntent?: DialogButton['intent'];
  customOnSubmit?: () => void;
  customOnCancel?: () => void;
}

export interface ConfirmationDialogProps extends ConfirmationOptions {
  isOpen: boolean;
  onSubmit: () => void;
  onClose: () => void;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  isOpen,
  title,
  descriptionElement,
  onSubmit,
  onClose,
  cancelButtonText = 'Cancel',
  cancelButtonIntent = 'default',
  confirmButtonText = 'Save',
  confirmButtonIntent = 'default',
}) => {
  return (
    <Dialog
      size='sm'
      title={title}
      content={descriptionElement}
      isOpen={isOpen}
      onClose={onClose}
      hideClose={true}
      className='xsDialog'
      buttonA={{
        appearance: 'outline',
        intent: cancelButtonIntent,
        text: cancelButtonText,
        onClick: onClose,
      }}
      buttonB={{
        appearance: 'primary',
        intent: confirmButtonIntent,
        text: confirmButtonText,
        onClick: onSubmit,
      }}
    />
  );
};

export default ConfirmationDialog;
